export function isNew(createdAt) {
  if (!createdAt) return false;
  const d = new Date(createdAt);
  if (isNaN(d.getTime())) return false;
  return (Date.now() - d.getTime()) < 24 * 60 * 60 * 1000;
}
